// extracted by mini-css-extract-plugin
export default {"home-container":"Home_home-container__k7q2e"};